import Component from '../component';

export default class SingleSubmitForm extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.resetSubmittedState();

    this.bindEvents();
  }

  bindEvents() {
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleFormComplete = this.handleFormComplete.bind(this);

    this.$element.on('submit.SingleSubmitForm', this.handleFormSubmit);
    this.$element.on('ajax:complete.SingleSubmitForm', this.handleFormComplete);
  }

  unbindEvents() {
    this.$element.off('submit.SingleSubmitForm', this.handleFormSubmit);
    this.$element.off(
      'ajax:complete.SingleSubmitForm',
      this.handleFormComplete
    );
  }

  resetSubmittedState() {
    this.submitted = false;
  }

  shouldSubmit() {
    return !this.submitted;
  }

  handleFormComplete() {
    // If our element has the remoteReloadingElement behavior,
    // the page is going to reload and we don’t want to make
    // the form submittable while it does.
    if (!this.$element.hasClass('remoteReloadingElement')) {
      this.resetSubmittedState();
    }
  }

  handleFormSubmit() {
    if (this.shouldSubmit()) {
      this.submitted = true;
    } else {
      return false;
    }
  }
}
